import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromDevice from '../_reducers/device';

export const selectDeviceState = createFeatureSelector<fromDevice.DeviceState>('devices');

export const selectAllDevices = createSelector(selectDeviceState, fromDevice.selectAll);

export const selectDeviceEntities = createSelector(selectDeviceState, fromDevice.selectEntities);

export const selectDeviceById = (id: number) =>
  createSelector(selectDeviceEntities, (entities) => entities[id]);

export const selectDeviceTotal = createSelector(selectDeviceState, fromDevice.selectTotal);

export const selectDeviceStateWithStatus = createSelector(
  selectDeviceState,
  selectAllDevices,
  (state, devices) => ({
    devices,
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
  })
);
